import React from "react";

import { Col, Row } from "react-bootstrap";

import { ButtonsContainer } from "../../IncidentReportForm";

import YesOrNo from "app/_pages/_healthSafetyEnvironment/YesOrNo.component";
import IncidentEvidences from "../../IncidentEvidences";

function IncidentEvidenceTab({
  form = {},
  onChange,
  error = {},
  setTab,
  onSubmit,
  evidences,
  evidencesErrors,
  onChangeEvidence,
  onChangeEvidenceFile,
  addEvidence,
  deleteEvidence,
}) {
  return (
    <div className="card p-3 pb-0 mt-3">
      <div className="simple-card-title">
        <h3 class="text-capitalize mb-0">Incident Evidence</h3>
      </div>
      <div className="ehsFormWrapper">
      <Row className="mb-4 justify-content-start align-items-center">
        <Col lg={4}>
          <YesOrNo
            title="Evidence Available"
            name="reportEvidencesRequired"
            value={form.reportEvidencesRequired === null ? false : form.reportEvidencesRequired}
            onChange={onChange}
          />
          <span className="small text-danger">
            {error?.reportEvidencesRequired}
          </span>
        </Col>
      </Row>
      {form.reportEvidencesRequired && (
          <div className="w-100">
            <IncidentEvidences
              dataArray={evidences}
              errorArray={evidencesErrors}
              onChange={onChangeEvidence}
              onChangeFile={onChangeEvidenceFile}
              onAdd={addEvidence}
              onDelete={deleteEvidence}
            />
          </div>       
      )}
       </div>
      <ButtonsContainer
        incidentStatus={form.incidentStatus}
        setTab={setTab}
        closeIncident={form.closeIncident}
        prev={5}
        // next={form.closeIncident === true ? 7 : 6}
        // noNext={form.closeIncident === true}
        // ...({form.closeIncident ? {next: 7} : {noNext: true}})
        onSubmit={onSubmit}
        {...(form.closeIncident !== true ? { noNext: true } : { next: 7 })}
      />
    </div>
  );
}

export default IncidentEvidenceTab;
